import React from 'react';
import SignupReportFull from '../../components/SignupReportFull/SignupReportFull';

export default SignupReportFull;
